//The modals component declaration
'use strict';
import angular from 'angular';
import './scripts/common.ctrls';
import './scripts/common.services';

angular.module('common', ['common.ctrls', 'common.services']);